import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { Input, InputRef } from 'antd'
import { PortalArticleYoutubeItem } from '../../../../models/PortalArtigoModel'
import { PortalEditorField } from '../PortalEditorField'
import {
  extractYoutubeVideoId,
  formatYoutubeVideoInput,
} from '../../helpers/youtube-utils'

interface Props {
  value: PortalArticleYoutubeItem
  autoEditToken?: number
  onAutoEditHandled?: () => void
  onChange: (value: PortalArticleYoutubeItem) => void
}

export function PortalYoutubeBlockEditor({
  value,
  autoEditToken,
  onAutoEditHandled,
  onChange,
}: Props) {
  const inputRef = useRef<InputRef>(null)
  const videoId = extractYoutubeVideoId(value.videoId)
  const hasInvalidValue = Boolean(value.videoId.trim()) && !videoId

  useEffect(() => {
    if (autoEditToken == null) return
    inputRef.current?.focus()
    onAutoEditHandled?.()
  }, [autoEditToken, onAutoEditHandled])

  return (
    <EditorLayout>
      <PortalEditorField label="URL do vídeo do YouTube">
        <Input
          ref={inputRef}
          value={formatYoutubeVideoInput(value.videoId)}
          placeholder="https://www.youtube.com/watch?v=..."
          onChange={(event) => onChange({ ...value, videoId: event.target.value })}
        />
      </PortalEditorField>
      {hasInvalidValue && (
        <ValidationMessage>
          Informe uma URL válida do YouTube ou o ID de um vídeo.
        </ValidationMessage>
      )}
      {videoId && (
        <PreviewFrame>
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
            title="Prévia do vídeo do YouTube"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </PreviewFrame>
      )}
    </EditorLayout>
  )
}

const EditorLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ValidationMessage = styled.span`
  color: #ea4335;
  font-size: 12px;
`

const PreviewFrame = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 8px;
  background: #122a41;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`
